/* The variants /products/<handle>.js leaves out.
 *
 * 🔴 THAT ENDPOINT LISTS AT MOST 250 VARIANTS (CATALOG's field traverse, 2026-09-24), and the band
 * families publish up to 1,500. A script that looked a saved variant up in `product.variants` found
 * nothing past the 250th and quietly fell back to the product: the wishlist chip lost its size, and
 * its add-to-cart and sold-out state were read from the wrong variant.
 *
 * The product page solved the same cap first (D-146): the server resolves ANY variant by `?variant=`,
 * and the product section renders it as `data-djh-selected-variant`, the one JSON shape
 * (snippets/djh-variant-json.liquid) the page script already reads. This asks for exactly that, only
 * for the ids that are missing, and adds them to `product.variants` so every later lookup is plain.
 *
 * `section_id=product` names the section FILE (sections/product.liquid), the same way the pickup
 * block asks for `djh-pickup`. The template key (`main`) does not work: measured 404, because the
 * rendered id is `template--<theme template id>__main`. One call is ~218 KB (the section carries
 * its own 250-variant list), so it runs only for ids the list is missing. A wrong id renders no
 * selected variant, and nothing is added.
 */
(function () {
  if (window.djhVariantLookup) return;

  function fetchVariant(handle, id) {
    const url = '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(id) + '&section_id=product';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const blob = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-djh-selected-variant]');
        const v = blob ? JSON.parse(blob.textContent) : null;
        // The server falls back to no variant for an id that is not this product's; only an exact id is kept.
        return v && String(v.id) === String(id) ? v : null;
      })
      .catch(() => null);
  }

  /** Make every id in `ids` findable in `product.variants`, fetching only the ones the list does not hold. */
  async function complete(handle, product, ids) {
    if (!product || !Array.isArray(product.variants)) return product;
    const have = new Set(product.variants.map((v) => String(v.id)));
    const missing = [...new Set((ids || []).filter(Boolean).map(String))].filter((id) => !have.has(id));
    const found = await Promise.all(missing.map((id) => fetchVariant(handle, id)));
    found.forEach((v) => { if (v) product.variants.push(v); });
    return product;
  }

  window.djhVariantLookup = { complete };
})();
